import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { UserInfoService } from 'src/app/Services/Utilities/user-info.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {

  time:any;
  release = false;
  htmlContent: string[] = [''];
  selectedIndex: number = 0 ;
  role: string[];

  constructor(
    private firestore: AngularFirestore,
    private toaster: ToastrService,
    private spinner: NgxSpinnerService,
  ) {}

  ngOnInit(): void {
    this.spinner.show();
    this.firestore.collection('Setting').doc('Deadline').get().forEach(e=>{
      if(e.exists){
        this.time = new Date(e.data().time.toDate());
        this.release = e.data().value;
      }
    })

    this.firestore.collection('Setting').doc('Announcement').get().forEach(e=>{
      if(e.exists)
        this.htmlContent = e.data().htmlContent;
    this.spinner.hide();
  })


  }

  update(){
    if(!this.time){
      this.toaster.warning("Please fill in");
      return;
    }
    this.time = new Date(new Date(this.time).setHours(23,59,59))
    this.spinner.show();

    this.firestore.collection('Setting').doc('Deadline').set({"time":this.time, value: this.release}).then(e=>{
      this.firestore.collection('Setting').doc('Announcement').set({"htmlContent":this.htmlContent}).then(e=>{
        this.toaster.success('Update Successful');
        this.spinner.hide();
      })
    })
  }

  select(i){
    this.selectedIndex =i;
  }

  add(){
    this.htmlContent.push('')
    this.selectedIndex = this.htmlContent.length-1;
  }

  delete(){
    this.htmlContent.splice(this.selectedIndex,1)
    this.selectedIndex = 0;
  }

  htmlEditorConfig = {
    editable: true,
    spellcheck: true,
    width: "auto",
    minWidth: "0",
    translate: 'no',
    enableToolbar: true,
    showToolbar: true,
    toolbar: [
    ["bold", "italic", "underline", "strikeThrough", "superscript", "subscript"],
    ["fontName", "fontSize", "color"],
    ["justifyLeft", "justifyCenter", "justifyRight", "justifyFull", "indent", "outdent"],
    ["cut", "copy", "delete", "removeFormat", "undo", "redo"],
    ["paragraph", "blockquote", "removeBlockquote", "horizontalLine", "orderedList", "unorderedList"],
    ["link", "unlink", "image"]
    ]
    };

  onchange(event){
  }

}
